import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface AddKnowledgeToCandidateResponse extends BackendResponse {}
export interface AddKnowledgeToCandidateParameters extends NextApiParams {
  knowledgeType: number;
  comment: string;
  level: number;
  expirationDate: string;
}

export const addKnowledgeToCandidate = withNextApi<
  AddKnowledgeToCandidateResponse,
  AddKnowledgeToCandidateParameters
>("/cvp/CvpAddKnowledgeToCandidate");
